import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseForm from 'containers/Base/BaseForm';
import { initialState, generalSection, validationSchema } from './options';
import API from 'services/api';
import { getRegionId, getSecurityId } from 'reducers/users';
import { getRegionCurrency } from 'reducers/region';
import { transform as transformFormData } from 'utils/DataTransform/Trips/tripTypeForm';
import { transform as transformServiceTypePriceRange } from 'utils/DataTransform/Trips/tripServiceTypeRange';
import { currencySymbol } from 'utils/currency-symbol';
import staticText from 'static/text_display.json';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import {
  tripTypeGridActions,
  tripTypeSelectors,
} from 'containers/Pages/Tasks/TripTypes';
import isEmpty from 'lodash/isEmpty';
import {
  assetTypeGridActions,
  assetTypeSelectors,
} from 'containers/Pages/Assets/AssetTypes';

const TransportTypeForm = ({
  closeForm,
  regionId,
  securityCompanyId,
  assetType,
  createTripType,
  updateTripType,
  editMode,
  data,
  services,
  regionCurrencySymbol,
  fetchListofAssetType,
}) => {
  const [serviceTypePriceRange, setServiceTypePriceRange] = useState({});
  const [selectedServiceType, setSelectedServiceType] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [currentFormValues, setCurrentFormValues] = useState({});

  const getServiceTypePriceRange = async serviceType => {
    try {
      const { data } = await API.getPriceRangeForServiceType(
        regionId,
        serviceType,
      );
      return data.data;
    } catch (err) {
      console.log(err);
      return err;
    }
  };
  const onChange = async values => {
    setSelectedCategory(values.vehicleCategory);
    if (
      !isEmpty(values) &&
      values.serviceType !== '' &&
      selectedServiceType !== values.serviceType
    ) {
      setCurrentFormValues(values);
      setSelectedServiceType(values.serviceType);
      const priceData = await getServiceTypePriceRange(values.serviceType);
      setServiceTypePriceRange(
        transformServiceTypePriceRange(priceData, regionCurrencySymbol),
      );
    }
  };
  const onCreate = async values => {
    Reflect.deleteProperty(values, 'srFlagFall');
    Reflect.deleteProperty(values, 'srSharePercentOnCost');
    const transformedTripData = transformFormData(values);
    await createTripType({
      ...transformedTripData,
      securityCompanyId,
      regionId,
    });
  };
  const onEdit = async values => {
    const tripId = values.id;
    Reflect.deleteProperty(values, 'id');
    Reflect.deleteProperty(values, 'srFlagFall');
    Reflect.deleteProperty(values, 'srSharePercentOnCost');
    const transformedTripData = transformFormData(values);
    updateTripType(tripId, {
      ...transformedTripData,
      securityCompanyId,
      regionId,
    });
  };

  useEffect(() => {
    fetchListofAssetType({ filters: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BaseForm
      edit={editMode}
      formTitle={
        editMode
          ? staticText.account_view.edit_transport_service_type
          : staticText.account_view.new_transport_service_type
      }
      initialValues={
        editMode ? data : initialState(serviceTypePriceRange, currentFormValues)
      }
      closeForm={closeForm}
      saveHoverText={
        editMode
          ? translatedKeyValueText('update_value_title', {
              value: currentFormValues.vehicleType,
            })
          : staticText.account_view.new_transport_service_type
      }
      onChange={onChange}
      generalSection={generalSection({
        services,
        assetType,
        selectedCategory,
        regionCurrencySymbol,
        serviceTypePriceRange,
      })}
      imageRequired={false}
      validationSchema={validationSchema(
        serviceTypePriceRange,
        regionCurrencySymbol,
      )}
      enableReinitialize={true}
      onSubmit={editMode ? onEdit : onCreate}
    />
  );
};

TransportTypeForm.propTypes = {
  close: PropTypes.func,
  regionId: PropTypes.string.isRequired,
  securityCompanyId: PropTypes.string.isRequired,
  createTripType: PropTypes.func,
  updateTripType: PropTypes.func,
  editMode: PropTypes.bool,
  data: PropTypes.object,
  services: PropTypes.array,
  regionCurrencySymbol: PropTypes.string,
  assetType: PropTypes.array,
  currentPage: PropTypes.string,
  fetchListofAssetTypePerView: PropTypes.func,
  fetchListofAssetType: PropTypes.func,
  closeForm: PropTypes.func,
};

const mapStateToProps = state => ({
  regionId: getRegionId(state),
  securityCompanyId: getSecurityId(state),
  regionCurrencySymbol: currencySymbol(getRegionCurrency(state)),
  assetType: assetTypeSelectors.getAssetTypeListTransformed(state),
  services: getSecurityCompanyServices(state),
  data: tripTypeSelectors.getTripTypeDetailsRaw(state),
});
const mapDispatchToProps = dispatch => ({
  createTripType: tripType =>
    dispatch(tripTypeGridActions.createRowEntry({ tripType })),
  updateTripType: (tripId, tripType) =>
    dispatch(tripTypeGridActions.updateRowEntry({ tripId, tripType })),
  fetchListofAssetType: filters =>
    dispatch(assetTypeGridActions.fetchGridList({ filters })),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransportTypeForm);
